<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @reload="$refs.header.query()"
      @openDetailDialog="openDetailDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @exportData="exportVisible = true"
      />
    </page-main>
    <el-dialog
      show-close
      :visible="exportVisible"
      width="500px"
      :title="$l('btn_export_batch') || '导出批次信息'"
      :close-on-click-modal="false"
      :before-close="() => (exportVisible = false)"
      :modal-append-to-body="false"
      :modal="false"
    >
      <div class="print_btn_group">
        <el-button plain @click="exportExcel('one')">
          {{ $l('btn_Template_One') || '模版一' }}
        </el-button>
        <el-button plain @click="exportExcel('two')">
          {{ $l('btn_Template_Two') || '模版二' }}
        </el-button>
      </div>
    </el-dialog>
    <DetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_order_batch_detail_info') || '订单交货批次详情'
      "
      :orderBatchCode="detailDialogOptions.code"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import DetailDialog from '../detail/dialog.vue'
export default {
  props: { orderCode: { type: String, default: '' } },
  components: { PageMain, PageHeader, DetailDialog },
  data() {
    return {
      tableData: [],
      loading: false,
      exportVisible: false,
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderBatchListApi({
          orderCode: this.orderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.setData()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ orderBatchCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderBatchCode,
      }
    },
    exportExcel(type) {
      const parms = { orderCode: this.orderCode }
      this.loadingOpen()
      this.$api
        .orderBatchGoodsCheckDataApi(parms)
        .then((res) => {
          const { status } = res
          if (status != 200) {
            this.loadingClose()
            return
          }
          const context = { ...parms, type, mode: 'A' }
          this.$api
            .SYS_EXPORT_TASK('factory-order-batch', context)
            .then((res) => {
              this.loadingClose()
              this.close()
              const { status } = res
              if (200 !== status) {
                this.$message.error(
                  this.$l('Description_Failed_to_add_export_task') ||
                    '导出任务添加失败'
                )
                return
              }
              this.$message({
                message:
                  this.$l('added_to_the_download_center') ||
                  '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
                type: 'success',
              })
            })
            .catch(() => {
              this.loadingClose()
              this.$message.error(
                this.$l('Description_Failed_to_add_export_task') ||
                  '导出任务添加失败'
              )
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
